import { TOUR_ACTIONS } from './tourConstants';
import { TAB_INDICES } from '../components/Profile/constants/profileConstants';

// Keys must match the flags in the `tours` object from GET /api/v1/user/tours.
// A step's `action` can be one action or an array of actions run in order.
export const tourConfig = {
  profile: {
    priority: 10,
    title: "New Profile Features",
    description: "We've added some exciting new features to help you trade better and stay connected.",
    steps: [
      {
        target: "relationship-manager-card",
        title: "Relationship Manager",
        description: "Connect directly with your dedicated relationship manager for personalized support.",
        // OPEN_TAB covers a user already on /profile with another tab open:
        // navigating alone wouldn't bring the targets into the DOM.
        action: [
          { type: TOUR_ACTIONS.NAVIGATE, path: "/profile" },
          { type: TOUR_ACTIONS.OPEN_TAB, component: "profile", tabIndex: TAB_INDICES.ACCOUNT_DETAILS },
        ],
      },
      {
        target: "whatsapp-number-row",
        title: "WhatsApp Updates",
        description: "Add your WhatsApp number to receive important trading alerts instantly.",
      },
      {
        target: "telegram-id-row",
        title: "Telegram Updates",
        description: "Link your Telegram ID for real-time notifications and market updates.",
      },
    ],
  },
};

// Own-property check so backend keys like "constructor" don't match Object.prototype
export const isTourAvailable = (tourId) => Object.prototype.hasOwnProperty.call(tourConfig, tourId);
